<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('coop_internship_postings')"
                        :isFilter="false" />
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('coop_internship_postings')"
                              :isFilter="false" />
            </template>
            <b-tabs v-model="activeTab" content-class="py-3 position-relative">
                <b-tab :title="$t('coop_internship_postings')" active>
                    <InternshipPostings />
                </b-tab>
                <b-tab :title="$t('events')">
                    <Events />
                </b-tab>
                <b-tab :title="$t('coop_career_counseling')">
                    <AdvisorAppointments />
                </b-tab>
                <b-tab :title="$t('coop_business_point')">
                    <BusinessPointEvents />
                </b-tab>
            </b-tabs>
        </app-layout>
    </div>
</template>
<script>
    //Template
    import AppLayout from '@/layouts/AppLayout';
    import Header from '@/layouts/AppLayout/Header'
    import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'

    //Page
    import InternshipPostings from './InternshipPostings';
    import Events from './Events';
    import AdvisorAppointments from './AdvisorAppointments';
    import BusinessPointEvents from './BusinessPointEvents';

    export default {
        components: {
            AppLayout,
            Header,
            HeaderMobile,
            InternshipPostings,
            Events,
            AdvisorAppointments,
            BusinessPointEvents
        },
        data() {
            return {
                activeTab: 0
            };
        },
        created() {
            if (this.$route.query.tab) {
                this.activeTab = parseInt(this.$route.query.tab);
            }
        },
        metaInfo() {
            return {
                title: this.$t('coop_internship_postings')
            }
        }
    }
</script>
